import { createFileRoute } from "@tanstack/react-router";
import { useEffect } from "react";
import i18n from "@/i18n";
import { buildHead } from "@/lib/seo";
import { DynamicLegalPage } from "@/components/pages/DynamicLegalPage";

export const Route = createFileRoute("/nl/algemene-voorwaarden")({
  head: () =>
    buildHead({
      lang: "nl",
      page: "home",
      title: "Algemene verkoopsvoorwaarden · 2AM Hospitality",
      description:
        "Algemene verkoopsvoorwaarden van toepassing op de diensten van 2AM Hospitality (KBO BE 0786 281 406).",
    }),
  component: () => {
    useEffect(() => {
      if (i18n.language !== "nl") i18n.changeLanguage("nl");
    }, []);
    if (i18n.language !== "nl") i18n.changeLanguage("nl");
    return <DynamicLegalPage slug="cgv" />;
  },
});
